var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-check-box",on:{"click":_vm.toggle}},[_c('img',{attrs:{"src":_vm.img}}),_vm._v(" "),(_vm.sChecked)?_c('div',{staticClass:"check-item"},[_c('a-icon',{attrs:{"type":"check"}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a650474","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/ImgCheckbox.vue
// module id = null
// module chunks = 